import React, {Suspense} from "react";
import {VipLevelAccordion} from "@housebets/housebets-x-package";
import {useVipLevelsData} from "./hooks/useVipLevelsData";
import { useIntl } from "react-intl";

export const VipLevels: React.FC = () => {
    const {$t} = useIntl();
    const {bronzeData, silverData, goldData, platinumData, pearlData, onyxData, diamondData, palladiumData, castleData} = useVipLevelsData();

    return (
        <>
            <Suspense fallback={<div></div>}>
                <>
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...bronzeData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...silverData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...goldData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...platinumData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...pearlData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...onyxData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...diamondData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...palladiumData}
                    />
                    <VipLevelAccordion
                        texts={{
                            status: {
                                complete: $t({id: "complete"}),
                                incomplete: $t({id: "incomplete"}),
                                inactive: $t({id: "inactive"}),
                                soon: $t({id: "soon"}),
                            },
                        }}
                        isLevelNameWhite
                        {...castleData}
                    />
                </>
            </Suspense>
        </>
    );
};

VipLevels.displayName = "VipLevels";
